import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useTableFormatter } from '@/share/hooks/common';

import { ref, toRaw, unref, reactive } from 'vue';
export default {
  __name: 'mg-org-search-view',
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const listPageRef = ref();
    const props = __props;
    const getSelectRows = () => {
      if (!listPageRef.value) {
        return [];
      }
      const radioRow = listPageRef.value.getRadioRow();
      return props.multiple ? (listPageRef.value.getCheckboxRows() || []).map(item => toRaw(unref(item))) : radioRow ? [toRaw(unref(radioRow))] : [];
    };
    const {
      useAreaFieldsFormatter
    } = useTableFormatter();
    const listPageOptions = reactive({
      toolbar: null,
      searchFields: [{
        field: 'search',
        title: '查找关键字',
        span: 24,
        itemRender: {
          name: 'VxeInput'
        }
      }],
      gridProps: {
        radioConfig: {
          trigger: 'row'
        },
        checkboxConfig: {
          trigger: 'row'
        }
      },
      columns: [{
        type: 'seq',
        title: '序号',
        width: 70,
        fixed: 'left'
      }, {
        type: props.multiple ? 'checkbox' : 'radio',
        title: '选择',
        width: 70
      }, {
        field: 'name',
        title: '组织机构名称',
        width: 220
      }, {
        field: 'contactPer',
        title: '联系人',
        width: 120
      }, {
        field: 'contactTel',
        title: '联系电话',
        width: 120
      }, {
        field: 'mobile',
        title: '手机号',
        width: 120
      }, {
        field: 'region',
        title: '行政区划',
        width: 220,
        formatter: useAreaFieldsFormatter()
      }, {
        field: 'address',
        title: '详细地址'
      }],
      queryConfig: {
        api: 'org.getPage'
      }
    });
    __expose({
      getSelectRows,
      confirmListener() {
        const rows = getSelectRows();
        if (!rows || rows.length === 0) return Promise.resolve(false);
        return Promise.resolve(rows);
      }
    });
    return (_ctx, _cache) => {
      const _component_mg_list_page = _resolveComponent("mg-list-page");
      return _openBlock(), _createBlock(_component_mg_list_page, _mergeProps({
        ref_key: "listPageRef",
        ref: listPageRef,
        id: "mg-org-search-view-table"
      }, _unref(listPageOptions)), null, 16);
    };
  }
};